import type { AgentReviewInlineConfig } from '@/versions/v1/shared/admin-seed';

export function nextAgentReviewInlineConfig(
  config: AgentReviewInlineConfig,
): AgentReviewInlineConfig {
  return { enabled: !config.enabled };
}

export function agentReviewInlineStatusLabel(enabled: boolean): 'ON' | 'OFF' {
  return enabled ? 'ON' : 'OFF';
}
